module.exports = {
	init: () => {
		window.jQuery('.openDiscount').on('click', openDiscount);
		window.jQuery('.toggleRates').on('click', toggleRates);

		window.jQuery('.theBuyBtn').on('click', continueOn);

		window.jQuery('.showHiddenTypes').on('click', showHiddenTypes);
	}
};

const continueOn = (e) => {
	let $this = window.jQuery(e.target);
	let $panel = $this.closest('.panel');
	let $checked = $panel.find('label.active input');
	let isJoint = $checked.closest('label').data('isjoint');
	let guid = $checked.val();
	let creditHash = $panel.find(`.panel-body ${isJoint === 1 ? '.joint' : '.single'} .credithash`).data('credithash');
	window.location.href = `/index.cfm/membership:home/setPrice/membershipTypeRate/${guid}?credit=${creditHash}`;
};

const openDiscount = () => {
	window.jQuery('#winDiscounts').modal('show');
};

const toggleRates = (e) => {
	let $type = window.jQuery(e.target).data('isjoint') ? 'joint' : 'single';

	if ($type === 'joint') {
		window.jQuery('.joint').removeClass('hide');
		window.jQuery('.single').addClass('hide');
		window.jQuery('.btnSingle').addClass('btn-default').removeClass('active btn-primary');
		window.jQuery('.btnJoint').addClass('active btn-primary').removeClass('btn-default');
	} else {
		window.jQuery('.joint').addClass('hide');
		window.jQuery('.single').removeClass('hide');
		window.jQuery('.btnSingle').addClass('active btn-primary').removeClass('btn-default');
		window.jQuery('.btnJoint').addClass('btn-default').removeClass('active btn-primary');
	}

	window.jQuery('.panel').each((junk, $panel) => {
		let $p = window.jQuery($panel);
		let $options = $p.find('.toggleRates');

		if ($options.length === 1) {
			let optJoint = parseInt(window.jQuery($options[0]).data('isjoint'), 10);
			let onlyJoint = optJoint === 1;
			let onlySingle = optJoint === 0;

			if (onlyJoint && $type === 'joint') {
				$p.find('.theBuyBtn').removeClass('disabled');
			} else if (onlySingle && $type === 'single') {
				$p.find('.theBuyBtn').removeClass('disabled');
			} else {
				$p.find('.theBuyBtn').addClass('disabled');
			}
		}
	});
};

/* if we have any isHiddenByDefault membership types, show them when the subtle link is clicked */
const showHiddenTypes = () => {
	window.jQuery('.isHiddenByDefault').removeClass('hide');
	window.jQuery('.showHiddenTypes').hide();
};
